exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editorStyle{background-color:#fff}.editorStyle .ql-editor p{color:#000 !important}", ""]);

// exports
